(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bluebird"), require("underscore"), require("@bingads-webui-universal/primitive-utilities"), require("@bingads-webui/reflection"), require("@bingads-webui/odata-bulk-upsert"), require("@bingads-webui/http-util"), require("@bingads-webui/url-util"));
	else if(typeof define === 'function' && define.amd)
		define(["bluebird", "underscore", "@bingads-webui-universal/primitive-utilities", "@bingads-webui/reflection", "@bingads-webui/odata-bulk-upsert", "@bingads-webui/http-util", "@bingads-webui/url-util"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("bluebird"), require("underscore"), require("@bingads-webui-universal/primitive-utilities"), require("@bingads-webui/reflection"), require("@bingads-webui/odata-bulk-upsert"), require("@bingads-webui/http-util"), require("@bingads-webui/url-util")) : factory(root["bluebird"], root["underscore"], root["@bingads-webui-universal/primitive-utilities"], root["@bingads-webui/reflection"], root["@bingads-webui/odata-bulk-upsert"], root["@bingads-webui/http-util"], root["@bingads-webui/url-util"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__39__, __WEBPACK_EXTERNAL_MODULE__40__, __WEBPACK_EXTERNAL_MODULE__41__, __WEBPACK_EXTERNAL_MODULE__42__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 35);
/******/ })
/************************************************************************/
/******/ ({

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(36);


/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(37);

Object.keys(_index).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _index[key];
    }
  });
});

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bulkUpsert = __webpack_require__(38);

Object.keys(_bulkUpsert).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bulkUpsert[key];
    }
  });
});

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.odataBulkUpsertPlugin = odataBulkUpsertPlugin;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _bluebird = _interopRequireDefault(__webpack_require__(6));

var _reflection = __webpack_require__(39);

var _odataBulkUpsert = __webpack_require__(40);

var _httpUtil = __webpack_require__(41);

var _primitiveUtilities = __webpack_require__(8);

var _urlUtil = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getCast(options) {
  return options && !_underscore.default.isEmpty(options.cast) ? `/${options.cast}` : '';
}

function getParent(options) {
  return options && !_underscore.default.isEmpty(options.parent) ? `${options.parent}/` : '';
}

function odataBulkUpsertPlugin(edm, {
  ServiceRoot,
  AccountID,
  AdvertiserCustomerID,
  bulkUpsertSchema
} = {}, {
  processOptions = _underscore.default.identity
} = {}) {
  if ((0, _reflection.hasOwnProperty)(edm, 'odata.bulkUpsert')) {
    return;
  }

  function getUrl({
    path,
    options
  }) {
    if (path) {
      const prefix = path.match(/\/Customers\([0-9]+\)\/Accounts\([0-9]+\)/);

      if (!_underscore.default.isEmpty(prefix)) {
        return (0, _urlUtil.join)(ServiceRoot, `${prefix[0]}/${getParent(options)}Default.BulkUpsert${getCast(options)}`);
      }
    }

    return (0, _urlUtil.join)(ServiceRoot, `/Customers(${AdvertiserCustomerID})/Accounts(${AccountID})/${getParent(options)}Default.BulkUpsert${getCast(options)}`);
  }

  function invalidateCache(entityName, ids) {
    if (edm['odata.cache']) {
      edm['odata.cache'].invalidateTypeCache(entityName, null, '');

      _underscore.default.each(ids, id => edm['odata.cache'].invalidateTypeCache(entityName, id, ''));
    }
  }

  function checkParsedResult(errors, result, entityName, ids) {
    if (!_underscore.default.isEmpty(errors)) {
      return _bluebird.default.reject({
        // eslint-disable-line prefer-promise-reject-errors
        entity: result,
        errors
      });
    }

    invalidateCache(entityName, ids);
    return result;
  }

  _underscore.default.each(bulkUpsertSchema, (bSchema, name) => {
    (0, _primitiveUtilities.merge)(edm.schema.schemas[`Model/${name}`], bSchema);
  });

  (0, _reflection.defineConstProperty)(edm, 'odata.bulkUpsert', (() => {
    const ResourceIdentifier = edm.resourceIdentifiers.ResourceIdentifier;

    ResourceIdentifier.prototype.bulkUpdate = function bulkUpdate(attrs, options = {}) {
      const schema = this.type.schema;

      if (options.batch) {
        if (_underscore.default.isUndefined(attrs.reqs)) {
          throw new Error('requests are required when batch bulkupserts.');
        }

        const reqs = _underscore.default.map(attrs.reqs, param => {
          const csvRows = (0, _odataBulkUpsert.serialize)(schema, _objectSpread({
            Id: attrs.Id
          }, param.data));
          const uri = getUrl({
            path: this.path,
            options
          });
          return {
            type: 'POST',
            url: uri,
            data: {
              CsvRows: csvRows
            }
          };
        });

        return _httpUtil.odata.batch(_underscore.default.defaults({
          reqs,
          path: options.path
        }, options)).then(responses => _bluebird.default.map(responses, (response, index) => {
          const _parse = (0, _odataBulkUpsert.parse)(response.data),
                results = _parse.results,
                errors = _parse.errors;

          const ret = (0, _odataBulkUpsert.populateIds)(results, attrs.reqs[index].data);
          return checkParsedResult(errors, ret, options.entityName || this.type.name, [attrs.Id || attrs.reqs[0].data.Id]);
        })).then(parsedResponse => _underscore.default.isFunction(options.processResponse) ? options.processResponse(parsedResponse) : parsedResponse);
      }

      const toSerialize = (0, _odataBulkUpsert.getAttrsToSerialize)(attrs.Id, attrs, schema);
      const CsvRows = (0, _odataBulkUpsert.serialize)(schema, toSerialize);
      return _httpUtil.odata.post(getUrl({
        path: this.path,
        options
      }), processOptions({
        data: {
          CsvRows
        }
      })).then(res => {
        const _parse2 = (0, _odataBulkUpsert.parse)(res),
              results = _parse2.results,
              errors = _parse2.errors;

        const ret = (0, _odataBulkUpsert.populateIds)(results, attrs);

        if (results && results.length && (0, _odataBulkUpsert.hasReadOnlyFields)(attrs, schema.properties)) {
          ret.Id = results[0].Id;
        }

        return checkParsedResult(errors, ret, options.entityName || this.type.name, [attrs.Id]);
      });
    };

    ResourceIdentifier.prototype.bulkUpdateMany = function bulkUpdateMany(idList, attrsList, options = {}) {
      const schema = this.type.schema;

      const toSerialize = _underscore.default.map(idList, (id, index) => (0, _odataBulkUpsert.getAttrsToSerialize)(id, attrsList[index], schema));

      const CsvRows = (0, _odataBulkUpsert.serialize)(schema, toSerialize);
      return _httpUtil.odata.post(getUrl({
        path: this.path,
        options
      }), _underscore.default.defaults(processOptions({
        data: {
          CsvRows
        }
      }), options)).then(res => {
        const _parse3 = (0, _odataBulkUpsert.parse)(res),
              results = _parse3.results,
              errors = _parse3.errors;

        const attrsListWithIds = (0, _odataBulkUpsert.populateIds)(results, attrsList);
        invalidateCache(options.entityName || this.type.name, idList);
        return _underscore.default.map(attrsListWithIds, (attrs, index) => ({
          entity: attrs,
          errors: (0, _odataBulkUpsert.extractEntityErrors)(errors, index)
        }));
      });
    };

    ResourceIdentifier.prototype.bulkCreate = function bulkCreate(attrs, options = {}) {
      const schema = this.type.schema;
      const CsvRows = (0, _odataBulkUpsert.serialize)(schema, attrs);
      return _httpUtil.odata.post(getUrl({
        path: this.path,
        options
      }), _underscore.default.defaults(processOptions({
        data: {
          CsvRows
        }
      }), options)).then(res => {
        const _parse4 = (0, _odataBulkUpsert.parse)(res),
              results = _parse4.results,
              errors = _parse4.errors;

        const ret = (0, _odataBulkUpsert.populateIds)(results, attrs);
        return checkParsedResult(errors, ret, options.entityName || this.type.name, [null]);
      });
    };

    ResourceIdentifier.prototype.bulkCreateMany = function bulkCreateMany(attrsList, options = {}) {
      const schema = this.type.schema;
      const CsvRows = (0, _odataBulkUpsert.serialize)(schema, attrsList);
      return _httpUtil.odata.post(getUrl({
        path: this.path,
        options
      }), _underscore.default.defaults(processOptions({
        data: {
          CsvRows
        }
      }), options)).then(res => {
        const _parse5 = (0, _odataBulkUpsert.parse)(res),
              results = _parse5.results,
              errors = _parse5.errors;

        const attrsListWithIds = (0, _odataBulkUpsert.populateIds)(results, attrsList);
        invalidateCache(options.entityName || this.type.name);
        return _underscore.default.map(attrsListWithIds, (attrs, index) => ({
          entity: attrs,
          errors: (0, _odataBulkUpsert.extractEntityErrors)(errors, index)
        }));
      });
    };

    ResourceIdentifier.prototype.bulkDestroy = function bulkDestroy(id, options = {}) {
      const schema = this.type.schema;
      const attrs = (0, _odataBulkUpsert.buildDestroyObject)(schema.parent, id, options.parentId);
      const CsvRows = (0, _odataBulkUpsert.serialize)(schema, attrs);
      return _httpUtil.odata.post(getUrl({
        path: this.path,
        options
      }), _underscore.default.defaults(processOptions({
        data: {
          CsvRows
        }
      }), options)).then(res => {
        const _parse6 = (0, _odataBulkUpsert.parse)(res),
              results = _parse6.results,
              errors = _parse6.errors;

        const ret = (0, _odataBulkUpsert.populateIds)(results, attrs);
        return checkParsedResult(errors, ret, options.entityName || this.type.name, [id]);
      });
    }; // put the plugin indicator


    return {};
  })());
}

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__39__;

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__40__;

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__41__;

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__42__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6__;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ })

/******/ });
});
